module.exports = __webpack_public_path__ + "static/media/zenith-banner.c2cf4077.jpg";